import Routes from './routes'
import ReactDOM from 'react-dom'

ReactDOM.render(Routes, document.getElementById('root'))
